module.exports = __webpack_public_path__ + "static/media/keto360slim-3.37d9699e.png";